import React from 'react';
import PropTypes from 'prop-types';
import styles from './Sidebar.module.scss';

function SidebarFooter(props) {
  return (
    <div className={styles.sidebarFooter + ' ' + props.className}>
      {props.children}
    </div>
  );
}

SidebarFooter.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};

export default SidebarFooter;